export enum enThakyouStatus {
  PAID = 3,
  ANALYSING = 8
}
